import { render, staticRenderFns } from "./releaseRequire.vue?vue&type=template&id=2f40972a&scoped=true"
import script from "./releaseRequire.vue?vue&type=script&lang=js"
export * from "./releaseRequire.vue?vue&type=script&lang=js"
import style0 from "./releaseRequire.vue?vue&type=style&index=0&id=2f40972a&prod&lang=css"
import style1 from "./releaseRequire.vue?vue&type=style&index=1&id=2f40972a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40972a",
  null
  
)

export default component.exports